export const subscriptionActivityRulesConfigFields = {
  // max_global_active_attendees

  max_weekly_active_attendees: {
    name: 'max_weekly_active_attendees',
    label: 'global.activities_activity_max_weekly_active_attendees_label',
    veeValidation: true,
    rules: [],
    help: 'global.activities_activity_max_weekly_active_attendees_help',
    showHelp: true,
    helpMode: 'tooltip',
    appendText: 'global.activity_rules_config.attendee_or_attendees',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },

  max_global_active_attendees: {
    name: 'max_global_active_attendees',
    label: 'global.activities_activity_max_global_active_attendees_label',
    veeValidation: true,
    rules: [],
    help: 'global.activities_activity_max_global_active_attendees_help',
    showHelp: true,
    helpMode: 'tooltip',
    appendText: 'global.activity_rules_config.attendee_or_attendees',
    fieldAttributes: {
      type: 'number',
      step: 1,
    },
  },
};
